module.exports = __webpack_public_path__ + "img/pr-24.aa34464d.png";